// Keyboard-shortcuts footer band — the signature forest-green strip at the bottom of Standup.
export function FooterBand() {
  return (
    <section className="footband">
      <div className="wrap foot-grid">
        <div>
          <div className="eyebrow">Keyboard shortcuts</div>
          <h2 className="display h2" style={{ margin: '10px 0 18px' }}>
            Move fast. <span className="accent">Type don't click.</span>
          </h2>
          <div className="shortcuts">
            <div><span className="kbd">J</span> Next conversation</div>
            <div><span className="kbd">K</span> Previous</div>
            <div><span className="kbd">Enter</span> Open thread</div>
            <div><span className="kbd">S</span> Send draft</div>
            <div><span className="kbd">O</span> Mark open</div>
            <div><span className="kbd">A</span> Mark awaiting</div>
            <div><span className="kbd">Z</span> Snooze…</div>
            <div><span className="kbd">R</span> Mark resolved</div>
            <div><span className="kbd">!</span> Mark spam</div>
            <div><span className="kbd">G</span> <span className="kbd">S</span> Jump to Standup</div>
            <div><span className="kbd">G</span> <span className="kbd">P</span> Jump to Pipeline</div>
            <div><span className="kbd">/</span> Search</div>
            <div><span className="kbd">?</span> Show all shortcuts</div>
          </div>
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, lineHeight: 1.6 }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>Right now</div>
          <p style={{ margin: 0 }}>
            You're signed in. New Gmail polls every 2 minutes. Snoozed threads wake on the minute.
            Etsy and Amazon threads arrive once their API access is approved.
          </p>
        </div>
      </div>
    </section>
  );
}
